import React from "react";
import { CURRENCY, ITEMSTATUS } from "../../../contants";


export const getBgColor = (type, kotQuantity, quantity) => {
  const percentage = (kotQuantity / quantity) * 100;
  if (type === 1) {
    return `linear-gradient(90deg,#ffff8f ${percentage}%, #fff ${percentage}%)`;
  }
  return ITEMSTATUS.find((d) => d.value === type)?.bgColor;
};

const OrderItemsList = ({
  orderItemsGrouped,
  handleQuantityChange,
  handleDeleteItem,
  onToggleDetailsAccordion,
  isDetailsAccordionOpen,
}) => {
  if (
    orderItemsGrouped.length === 0 ||
    orderItemsGrouped.every((kot) => kot.items.length === 0)
  ) {
    return (
      <div className="text-center text-muted py-5">
        <div style={{ fontSize: "48px", opacity: 0.3 }}>
          <i className="mdi mdi-basket-outline"></i>
        </div>
        <p className="mb-0">No items added yet</p>
      </div>
    );
  }

  return (
    <>
      {orderItemsGrouped.map(
        (kot, kotGroupIndex) =>
          kot.items.length > 0 && (
            <div key={kotGroupIndex} className="mt-2 px-2">
              {/* KOT Header */}
              <div className="bg-purple text-white rounded px-2 py-1 mb-2 font-weight-bold small">
                {kot.kotNumber ? `KOT ${kot.kotNumber}` : "Current KOT"}
              </div>

              {/* KOT Items */}
              {kot.items.map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className={`d-flex align-items-center justify-content-between p-2 ${
                    itemIndex === kot.items.length - 1 ? "" : "border-bottom"
                  }`}
                  style={{ background: getBgColor(item.itemStatusId, item.kotQuantity, item.quantity) }}
                >
                  <div className="flex-grow-1">
                    <div className="font-weight-bold small">
                      {item.itemName}
                    </div>
                    <div className="text-dark small">
                      {CURRENCY}
                      {item.itemPrice} × {item.quantity} ={" "}
                      {item.itemPrice * item.quantity}
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-1">
                    <button
                      className="btn btn-outline-dark btn-sm p-0"
                      style={{ width: "28px", height: "28px" }}
                      onClick={() =>
                        handleQuantityChange(item, kot.kotIndex, -1)
                      }
                      disabled={item.quantity <= 1}
                    >
                      <i className="mdi mdi-minus"></i>
                    </button>
                    <span
                      className="font-weight-bold mx-1"
                      style={{
                        minWidth: "24px",
                        textAlign: "center",
                      }}
                    >
                      {item.quantity}
                    </span>
                    <button
                      className="btn btn-outline-dark btn-sm p-0"
                      style={{ width: "28px", height: "28px" }}
                      onClick={() =>
                        handleQuantityChange(item, kot.kotIndex, 1)
                      }
                    >
                      <i className="mdi mdi-plus"></i>
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm ml-1 p-0"
                      style={{ width: "28px", height: "28px" }}
                      onClick={() =>
                        handleDeleteItem(item, kot.kotNumber, kot.kotIndex)
                      }
                    >
                      <i className="mdi mdi-delete-outline"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )
      )}

      {/* Order Details Accordion - This is now integrated in the parent component */}
    </>
  );
};

export default OrderItemsList;
